import { useState, useCallback, useEffect } from 'react';

/**
 * Custom hook for managing task table sorting state
 *
 * Handles the conversion between the legacy sortProp/sortReverse props
 * and the new FlexTable sortModel format
 */
export const useTaskSorting = ({ sortProp, sortReverse, onSort }) => {
  const [sortModel, setSortModel] = useState([]);

  // Convert legacy props to sortModel format
  useEffect(() => {
    if (sortProp) {
      setSortModel([
        {
          field: sortProp,
          sort: sortReverse ? 'desc' : 'asc',
        },
      ]);
    } else {
      setSortModel([]);
    }
  }, [sortProp, sortReverse]);

  // Handle sort model changes and call the legacy onSort callback
  const handleSortModelChange = useCallback(
    (newSortModel) => {
      setSortModel(newSortModel);

      if (newSortModel.length > 0) {
        const { field, sort } = newSortModel[0];
        onSort(field, sort === 'desc');
      } else {
        onSort('', false);
      }
    },
    [onSort]
  );

  return {
    sortModel,
    handleSortModelChange,
  };
};
